import { render } from "./RolesPermissions.vue?vue&type=template&id=f04d2afc"
import script from "./RolesPermissions.vue?vue&type=script&lang=js"
export * from "./RolesPermissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__